export default class LocalDB {
  static alias = {
    role: 'r',
    userId: 'uid',
    token: 't',
    refreshToken: 'rt',
    organizations: 'orgs',
    organization: 'org',
    sessionId: 'sid',
    sessionExpiresAt: 'sexp',
  };

  static get(name: string): string | null {
    return window.localStorage.getItem(name);
  }

  static set(name: string, value: string): void {
    window.localStorage.setItem(name, value);
  }

  static remove(name: string): void {
    window.localStorage.removeItem(name);
  }
}
